import { render, staticRenderFns } from "./wx-payment.vue?vue&type=template&id=6865886b&scoped=true&"
import script from "./wx-payment.vue?vue&type=script&lang=js&"
export * from "./wx-payment.vue?vue&type=script&lang=js&"
import style0 from "./wx-payment.vue?vue&type=style&index=0&id=6865886b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6865886b",
  null
  
)

export default component.exports